import React from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Tag } from 'transfix-ui/components/Tag'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { ITrailerStatesEnum } from 'types/graphqlTypes'
import { RightArrowIcon, InfoIcon, RolledIcon } from 'transfix-icons'
import { Card, TAG_SIZE, Tooltip } from 'transfix-ui'
import { statusTagMap } from '../schema/TrailerSchema'

const useStyles = makeStyles(() => ({
  card: {
    marginBottom: 10,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    '& .dpl-tag-dark': {
      backgroundColor: brandColors.coolGray3,
      borderColor: brandColors.coolGray3,
    },
    '& .dpl-tag-dark:hover': {
      borderColor: `${brandColors.coolGray3} !important`,
    },
  },
  column: {
    flex: '3 1 0',
  },
  columnNoStrech: {
    display: 'flex',
  },
  bold: {
    fontWeight: 'bold',
  },
  spaceTop: {
    marginTop: 3,
  },
  spaceRight: {
    marginRight: 3,
  },
  coolGray5: {
    color: brandColors.coolGray5,
  },
}))

export interface ITrailerItemsProps {
  arrivedAt?: string
  arrivedAtNote?: string
  id: string
  loadId?: string
  location?: string
  note?: string
  number: string
  status?: ITrailerStatesEnum
  selectedCarrierId: string
}

const TrailerItem = ({
  arrivedAt = '—',
  arrivedAtNote = '—',
  id,
  loadId = '—',
  location = '—',
  note = '',
  number,
  status = ITrailerStatesEnum.inactive,
  selectedCarrierId,
}: ITrailerItemsProps) => {
  const classes = useStyles()
  const history = useHistory()

  const tagItem = statusTagMap[status]

  const handleDetailClick = () => {
    history.push(`/equipment/trailer/${selectedCarrierId}/${id}`)
  }

  return (
    <Card className={classes.card}>
      <div className={classes.container}>
        <div className={classes.column}>
          <div className={classes.bold}>#{number}</div>
          <div className={classNames(classes.coolGray5, classes.spaceTop)}>{loadId}</div>
        </div>
        <div className={classes.column}>
          <Tag label={tagItem?.label} size={TAG_SIZE.xsmall} tagStyle={tagItem?.style} />
          <div className={classNames(classes.container, classes.spaceTop)}>
            <div className={classNames(classes.coolGray5, classes.spaceRight)}>{location}</div>
            {note && (
              <Tooltip
                position='top'
                type='dark'
                effect='solid'
                trigger={<InfoIcon color='coolGray5' size='medium' />}>
                {note}
              </Tooltip>
            )}
          </div>
        </div>
        <div className={classes.column}>
          <div className={classes.container}>
            <div className={classNames(classes.container, classes.spaceRight)}>
              <RolledIcon color='black' size='medium' />
            </div>
            {arrivedAtNote}
          </div>
          <div className={classNames(classes.coolGray5, classes.spaceTop)}>{arrivedAt}</div>
        </div>
        <div className={classes.columnNoStrech}>
          <IconButton
            Icon={RightArrowIcon}
            label='Trailer Details'
            size='large'
            color='tertiary'
            onClick={handleDetailClick}
          />
        </div>
      </div>
    </Card>
  )
}

export default TrailerItem
